 
import CTNButton from '@ctn/ui/components/ctn-button';

import { LegalSection } from '@/components/LegalSection';


import type { ReactElement } from 'react';

const PoliticaCookies = (): ReactElement => {
	const showPoliticaCookies = () => {
		if (document.cookie.includes('klaro')) {
			global.window.klaro.show();
		} else {
			const elemento = document.querySelector('.cn-learn-more') as HTMLButtonElement;
			if (elemento) {
				elemento?.click();
			}
		}
	};
	return (
		<div className="p-legal">
			<article className="[ u-flow ]">
				<h1 className="p-legal__tit">Política de cookies</h1>
				<LegalSection>
					<p className="u-mt-24">
						De conformidad con el artículo 22.2 de la Ley 34/2002 de Servicios de la Sociedad de la información (LSSI), le informamos que esta web del Portal Notarial de Empresas y Profesionales del CONSEJO GENERAL DEL NOTARIADO hace uso de dispositivos de almacenamiento y recuperación de datos, llamados cookies.
					</p>
				</LegalSection>
				<LegalSection title="Qué son las Cookies" >
					<p>
						Las cookies son archivos informáticos que las páginas web pueden colocar en el ordenador que las visita para obtener pautas y datos de navegación que puedan ser después recuperados y tratados, por el titular de la web o por terceros, para prestar servicios concretos, estudiar el comportamiento del internauta para el envío de publicidad, para el desarrollo de mejoras o nuevos productos y servicios, etc.
					</p>
				</LegalSection>
				<LegalSection title="Finalidad del uso de cookies">
					<p>
						Actualmente nuestro uso de las cookies tiene fines limitados. Usamos las cookies analíticas para hacer un seguimiento y análisis de las visitas que recibimos a nuestra web, cuándo entran, cuáles son las secciones o artículos más visitados y de qué zona geográfica vienen. También, como usamos cookies técnicas tenemos un plugin que instala cookies con el fin de saber quién ha aceptado o cerrado nuestro banner, y por lo tanto en su próxima visita le recordará –siempre que no haya borrado sus datos de navegación y cookies-.
					</p>
				</LegalSection>
				<LegalSection title="Base legal del uso de cookies">
					<p>
						La base legal es el consentimiento del usuario de las cookies analíticas mediante el banner de configuración de cookies, y el cumplimiento de una relación de servicios y el interés legítimo en el caso de las cookies técnicas.
					</p>
				</LegalSection>
				<LegalSection title="Protección de datos">
					<p>
						Usamos cookies con el único ánimo de conocer las estadísticas de la página web (post más visitados, tiempo de lectura, etc.). En la política de privacidad del Portal Notarial del Ciudadano se informa del tratamiento de datos que realizamos sobre la información recogida por las cookies instaladas en esta página web.
					</p>
				</LegalSection>
				<LegalSection title="Protección de datos">
					<div>
						<strong className="p-legal__subtit u-mt-16">¿Para qué se usan las cookies?</strong>
						<p className="u-mt-16">
							Las cookies recogen información del usuario, sus dispositivos, zonas geográficas, ip, preferencias, etc. Todo depende del tipo de cookies que use la web que visitan.
						</p>
						<section className="u-mt-24">
							<strong className="p-legal__subtit">¿Qué tipos de cookies existen?</strong>
							<p className="u-mt-16">Las cookies pueden catalogarse según 3 criterios:</p>
							<ol className="p-legal__list">
								<li>Entidad que las gestiona: Si son propias o de terceros.</li>
								<li>Plazo en que permanecen activas: Cookies de sesión o persistentes</li>
								<li>Según su afinidad</li>
								<ul className="o-list o-list--bullet">
									<li>Cookies técnicas.</li>
									<li>Cookies de personalización.</li>
									<li>Cookies de análisis.</li>
									<li>Cookies de publicitarias.</li>
									<li>Cookies de publicidad.</li>
								</ul>
							</ol>
						</section>
						<section className="u-mt-32">
							<strong className="p-legal__subtit">¿Cómo administro las cookies de mis dispositivos?</strong>
							<p className='u-mt-16'>
								El usuario elige si acepta o no la instalación de cookies en sus dispositivos. Puede elegir el bloqueo directo de la instalación de las cookies desde su navegador, así como también puede elegir configurar la instalación de unas y el rechazo de otras.
							</p>
							<CTNButton
								className="u-mt-16"
								mode="secondary"
								variant="outline"
								label="Modificar mi configuración de cookies"
								size="size-40"
								onClick={showPoliticaCookies}
							/>
						</section>
						<section className="u-mt-24">
							<strong className="p-legal__subtit">¿Cómo configurar las cookies según su navegador?</strong>
							<p className="u-mt-16">
								Según el navegador que use, usted puede configurarlo para que acepte o no las cookies de las páginas que visita. Puede realizar desde un bloqueo total (no recomendado ya que eso le impedirá el disfrute de muchas características de las webs, entre ellas el no poder usar las zonas de cuenta privada, etc.)
							</p>
							<p className="u-mt-16">Esta es la ruta para los navegadores más conocidos:</p>

							<ul className="[ o-list o-list--bullet ]">
								<li>
									<strong>Internet Explorer:</strong> Herramientas &gt; Opciones de Internet &gt; Privacidad &gt;
									Configuración. Para más información, puede consultar el soporte de Microsoft o la
									Ayuda del navegador.
								</li>
								<li>
									<strong>Firefox:</strong> Herramientas &gt; Opciones &gt; Privacidad &gt; Historial &gt;
									Configuración Personalizada. Para más información, puede consultar el soporte de
									Mozilla o la Ayuda del navegador.
								</li>
								<li>
									<strong>Chrome:</strong> Configuración &gt; Mostrar opciones avanzadas &gt; Privacidad -&gt;
									Configuración de contenido. Para más información, puede consultar el soporte de
									Google o la Ayuda del navegador.
								</li>
								<li>
									<strong>Safari:</strong> Preferencias &gt; Seguridad. Para más información, puede consultar el
									soporte de Apple o la Ayuda del navegador.
								</li>
								<li>
									<strong>Opera:</strong> Configuración &gt; Opciones &gt; Avanzado &gt; Para más información, puede
									consultar el soporte de Opera o la Ayuda del navegador.
								</li>
							</ul>
						</section>
						<section className="u-mt-24">
							<strong className="p-legal__subtit">Cookies utilizadas en esta web</strong>
							<p className='u-mt-16'>
								En esta web utilizamos cookies propias, y cookies de terceros, es decir, que la información es recogida por ese tercero titular de la cookie, y que ANCERT tiene acceso a ella a través de un panel de información.
							</p>

							<table className="p-legal__table u-mt-16">
								<colgroup>
									<col width="18.33" />
									<col width="18.33" />
									<col width="18.33" />
									<col width="45%" />
								</colgroup>
								<thead>
									<tr className="p-legal__table-tr">
										<th className="p-legal__table-th">COOKIE</th>
										<th className="p-legal__table-th">PROPIETARIO</th>
										<th className="p-legal__table-th">DURACIÓN</th>
										<th className="p-legal__table-th">INFORMACIÓN QUE NOS FACILITA</th>
									</tr>
								</thead>
								<tbody>
									<tr className="p-legal__table-tr">
										<td className="p-legal__table-td">viewed_cookie_policy</td>
										<td className="p-legal__table-td">Plugin propio</td>
										<td className="p-legal__table-td">1 año</td>
										<td className="p-legal__table-td">
											Utilizada para mostrar o no, el aviso de la primera capa de información sobre el uso de cookies por la web.
										</td>
									</tr>
									<tr className="p-legal__table-tr">
										<td className="p-legal__table-td">_ga</td>
										<td className="p-legal__table-td">Google Analytics</td>
										<td className="p-legal__table-td">2 años desde creación o modificación</td>
										<td className="p-legal__table-td">
											Utilizada para mostrar o no, el aviso de la primera capa de información sobre el uso de cookies por la web.
										</td>
									</tr>
									<tr className="p-legal__table-tr">
										<td className="p-legal__table-td">_gat</td>
										<td className="p-legal__table-td">Google Analytics</td>
										<td className="p-legal__table-td">
											10 minutos desde creación o modificación
										</td>
										<td className="p-legal__table-td">
											Se usa para diferenciar entre los diferentes objetos de seguimiento creados en la sesión.
										</td>
									</tr>
									<tr className="p-legal__table-tr">
										<td className="p-legal__table-td">_gid</td>
										<td className="p-legal__table-td">&nbsp;</td>
										<td className="p-legal__table-td">1 año desde su creación</td>
										<td className="p-legal__table-td">
											Se usa para diferenciar entre los diferentes objetos de seguimiento creados en la sesión.
										</td>
									</tr>
								</tbody>
							</table>
							<section className="u-mt-24">
								<strong className="p-legal__subtit">Otras cookies de terceros</strong>
								<p className='u-mt-16'>
									Así mismo, y debido a la tecnología utilizada para crear nuestra página web, usted podrá encontrar varias de las cookies, técnicas y de sesión de terceros como WordPress, google, etc.: wordpress_test_cookie, viewed_cookie_policy, wordpress_logged_in_; wp-settings-time. Así como las propias de google o del buscador que use para visitarnos. Estas cookies en muchos casos, ni son instaladas por el titular de la web, ni se tiene ningún tipo de control o se recibe/conoce información sobre ellas.
								</p>
							</section>
							<section className="u-mt-24">
								<strong className="p-legal__subtit">Actualizaciones</strong>
								<p className='u-mt-16'>
									El CONSEJO GENERAL DEL NOTARIADO se reserva el derecho a modificar en cualquier momento nuestra política de cookies, así como las cookies utilizadas en la web. El fin de las modificaciones será siempre la mejora respecto a los cambios normativos o desarrollos tecnológicos.
								</p>
							</section>
						</section>
					</div>
				</LegalSection>
			</article>
		</div>

	);
};

export default PoliticaCookies;
